const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

/**
 * Resolve any image source to a displayable URL.
 *
 * - data: URLs  (legacy base64 judgments/infographics)  → returned as-is
 * - http(s):// URLs (external / CDN)                    → returned as-is
 * - storage paths  (e.g. "litigation-india/...")         → proxied via backend
 *
 * Pass `opts.w` (target width in px) to request an on-demand downscaled WebP
 * variant from the backend. This is the single biggest page-weight lever: a
 * legacy multi-MB photo is delivered as a few-KB WebP sized for its container.
 * Rule of thumb: pass ~2× the CSS display width for crisp retina rendering.
 */
export function imageUrl(src, opts) {
  if (!src) return null;
  if (src.startsWith("data:")) return src;
  if (src.startsWith("http://") || src.startsWith("https://")) return src;
  const clean = src.startsWith("/") ? src.slice(1) : src;
  let url = `${BACKEND_URL}/api/public/images/${clean}`;
  if (opts && opts.w) {
    const params = new URLSearchParams();
    params.set("w", String(Math.round(opts.w)));
    if (opts.q) params.set("q", String(opts.q));
    url += `?${params.toString()}`;
  }
  return url;
}

export default imageUrl;
